import { NavLink } from 'react-router-dom';
import { useMemo } from 'react';
import { LayoutGrid, ShoppingCart, UserCircle2, Wifi } from 'lucide-react';
import { useAppStore } from '../store';
import { useHaptic } from '../hooks/useHaptic';
import { useAdminPendingHaptic, useAdminPendingQueueCounts } from '../hooks/useAdminPendingQueueCounts';
import { canAccessAdminUi } from '../adminAccess';

const tabs = [
  { to: '/catalog',    icon: LayoutGrid,    label: 'Каталог' },
  { to: '/smart-home', icon: Wifi,          label: 'Умный дом' },
  { to: '/cart',       icon: ShoppingCart,  label: 'Корзина' },
  { to: '/profile',    icon: UserCircle2,   label: 'Профиль' },
];

export default function BottomNav() {
  const cart = useAppStore((s) => s.cart);
  const role = useAppStore((s) => s.role);
  const token = useAppStore((s) => s.token);
  const telegramId = useAppStore((s) => s.telegramId);
  const authAdminHint = useAppStore((s) => s.authAdminHint);
  const showAdminChrome = useMemo(
    () => canAccessAdminUi({ role, telegramId, serverAdminPanelHint: authAdminHint }),
    [role, telegramId, authAdminHint],
  );
  const haptic = useHaptic();
  const { pendingTotal } = useAdminPendingQueueCounts(Boolean(token && showAdminChrome));
  useAdminPendingHaptic(pendingTotal, showAdminChrome, haptic);

  return (
    <>
    <div aria-hidden className="app-bottom-dock-fill" />
    <nav className="bottom-nav fixed left-3 right-3 flex z-50 rounded-3xl overflow-hidden"
      style={{ bottom: `calc(env(safe-area-inset-bottom, 0px) + var(--app-nav-lift, 8px))` }}>
      {tabs.map(({ to, icon: Icon, label }) => (
        <NavLink
          key={to}
          to={to}
          onClick={() => haptic.selection()}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center py-2.5 min-h-[56px] gap-0.5 text-[10px] font-semibold tracking-wide transition-all duration-150 ${
              isActive
                ? 'text-[var(--cyan-bright)]'
                : 'text-[var(--text-3)] hover:text-[var(--text-2)]'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <div className="relative">
                <div
                  className={`transition-all duration-200 ${isActive ? 'p-2 rounded-full' : 'p-1.5 rounded-2xl'}`}
                  style={isActive ? {
                    background: 'rgba(99,179,237,0.18)',
                    boxShadow:
                      '0 0 20px rgba(99,179,237,0.42), 0 0 2px rgba(99,179,237,0.35) inset',
                    border: '1px solid rgba(144,205,244,0.35)',
                  } : {}}
                >
                  <Icon
                    size={20}
                    strokeWidth={isActive ? 2.2 : 1.6}
                    color={isActive ? 'var(--cyan-bright)' : undefined}
                  />
                </div>
                {to === '/cart' && cart.length > 0 && (
                  <span
                    className="absolute -top-0.5 -right-0.5 text-white text-[9px] rounded-full w-4 h-4 flex items-center justify-center font-bold leading-none"
                    style={{ background: 'var(--cyan)', boxShadow: '0 0 8px var(--cyan-glow)' }}
                  >
                    {cart.length > 9 ? '9+' : cart.length}
                  </span>
                )}
                {to === '/profile' && showAdminChrome && pendingTotal > 0 && (
                  <span
                    className="absolute -top-0.5 -right-0.5 text-white text-[9px] rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center font-bold leading-none animate-pulse"
                    style={{ background: '#FC814A', boxShadow: '0 0 10px rgba(252,129,74,0.55)' }}
                  >
                    {pendingTotal > 99 ? '99+' : pendingTotal}
                  </span>
                )}
              </div>
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
    </>
  );
}
